export class PremierServiceProductTypeDTO{
    public id!: string;
    public name!: string;
}